import { background, border } from "@chakra-ui/react";

export default {
    parts: [
        'container',
        'mobileContainer',
        'promoCodeWrapper',
        'heading',
        'contentStack',
        'detailsStack',
        'row',
        'rowText',
        'shippingLabelWrap',
        'shippingLabel',
        'postalCodeContainer',
        'postalCodeText',
        'postalCodeActions',
        'postalCodeButton',
        'totalRow',
        'totalText',
        'pointsStack',
        'pointsBanner',
        'pointsBannerText',
        'accordionHeader',
        'accordionTitle',
        'accordionAmount',
        'accordionPanel',
        'summaryStack',
        'rowTextSavings',
        'savingsAccordion',
        'savingsAccordionItem',
        'savingsAccordionButton',
        'savingsHeaderContent',
        'savingsHeaderLabelWrap',
        'savingsAccordionArrow',
        'savingsAccordionArrowExpanded',
        'savingsAccordionPanel',
        'savingsBreakdownStack',
        'savingsBreakdownRow',
        'savingsBreakdownTextStack',
        'savingsBreakdownDetail',
        'savingsBreakdownRowText',
        'itemsAccordion',
        'itemsAccordionItem',
        'itemsAccordionButton',
        'itemsHeaderContent',
        'itemsAccordionPanel',
        'editCartLink',
        'mobileTopBar',
        'mobileTopBarTotalWrap',
        'mobileTopBarLabel',
        'mobileTopBarTotal',
        'mobileViewOrderButton',
        'checkoutProductListStack',
    ],
    baseStyle: {
        container: {
            position: 'relative',
            spacing: 8,
            background: 'white',
            zIndex: 1
        },
        mobileContainer: {
            mx: 4,
            mt: '18px'
        },
        promoCodeWrapper: {
            w: 'full'
        },
        heading: {
            textStyle: 'webH4'
        },
        contentStack: {
            spacing: 5,
            align: 'flex-start'
        },
        detailsStack: {
            w: 'full',
            gap: 2
        },
        row: {
            justify: 'space-between'
        },
        rowText: {
            textStyle: 'bodyXsSRegular'
        },
        shippingLabelWrap: {
            alignItems: 'center'
        },
        shippingLabel: {
            lineHeight: 1,
            textStyle: 'bodySmRegular',
            mr: 2
        },
        postalCodeContainer: {
            color: 'gray.500',
            maxWidth: '220px'
        },
        postalCodeText: {
            fontSize: 'xs'
        },
        postalCodeActions: {
            direction: 'column',
            align: 'flex-start'
        },
        postalCodeButton: {
            color: 'gray.500',
            fontSize: 'xs',
            textDecoration: 'underline'
        },
        totalRow: {
            w: 'full',
            justify: 'space-between',
            mt: 3
        },
        totalText: {
            textStyle: 'webH3',
        },
        pointsStack: {
            spacing: 5,
            w: 'full'
        },
        pointsBanner: {
            justify: 'center',
            bg: 'gray.200',
            py: '2',
            px: '4'
        },
        pointsBannerText: {
            color: 'darkPink',
            fontWeight: '500',
            textAlign: 'center',
            fontSize: '14px',
            lineHeight: '18px'
        },
        accordionHeader: {
            alignItems: 'center',
            width: '100%',
            columnGap: 2
        },
        accordionTitle: {
            textStyle: 'bodySmBold',
            textTransform: 'uppercase',
            flexGrow: 1,
            textAlign: 'left'
        },
        accordionAmount: {
            textStyle: 'bodySmBold',
            textTransform: 'uppercase'
        },
        accordionPanel: {
            spacing: 5,
            pb: 4
        },
        summaryStack: {
            gap: 5
        },
        rowTextSavings: {
            textStyle: 'bodyXsSRegular',
            color: 'webTypo.textSale'
        },
        savingsAccordion: {
            w: 'full'
        },
        savingsAccordionItem: {
            border: 'none'
        },
        savingsAccordionButton: {
            p: 0,
            _hover: {bg: 'transparent'}
        },
        savingsHeaderContent: {
            w: 'full',
            justify: 'space-between',
            alignItems: 'center'
        },
        savingsHeaderLabelWrap: {
            alignItems: 'center',
            gap: 1
        },
        savingsAccordionArrow: {
            transition: 'transform 0.2s ease-in-out',
            transform: 'rotate(0deg)'
        },
        savingsAccordionArrowExpanded: {
            transform: 'rotate(180deg)'
        },
        savingsAccordionPanel: {
            pt: 4,
            px: 0
        },
        savingsBreakdownStack: {
            gap: 4
        },
        savingsBreakdownRow: {
            justify: 'space-between',
            align: 'center'
        },
        savingsBreakdownTextStack: {
            spacing: 0
        },
        savingsBreakdownDetail: {
            textStyle: 'bodyXsSBold',
        },
        savingsBreakdownRowText: {
            textStyle: 'bodyXsSRegular'
        },
        itemsAccordion: {
            w: 'full',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeDefault'
        },
        itemsAccordionItem: {
            border: 'none'
        },
        itemsAccordionButton: {
            p: 0,
            _hover: {bg: 'transparent'}
        },
        itemsHeaderContent: {
            w: 'full',
            justify: 'space-between',
            alignItems: 'center',
            pb: 4,
            pt: 6
        },
        itemsHeaderText: {
            textStyle: 'bodyMdRegular'
        },
        itemsAccordionPanel: {
            py: '27px',
            px: 0
        },
        editCartLink: {
            textStyle: 'bodyXsSRegular',
            textDecoration: 'underline',
            display: 'block',
            mb: 4,
            alignSelf: 'flex-start'
        },
        mobileTopBar: {
            justify: 'space-between',
            alignItems: 'center',
            p: 4,
            backgroundColor: 'webTheme.backgroundPrimaryBrand'
        },
        mobileTopBarTotalWrap: {
            alignItems: 'center',
            gap: 1
        },
        mobileTopBarLabel: {
            textStyle: 'bodyXsBold'
        },
        mobileTopBarTotal: {
            textStyle: 'bodyXsBold'
        },
        mobileViewOrderButton: {
            textStyle: 'bodyXsSRegular',
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        checkoutProductListStack: {
            spacing: 3
        }
    },
    variants: {
        checkout: {
            mobileContainer: {
                mt: 0
            }
        }
    }
}
